"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var automation_attribute_1 = __importDefault(require("../../_helpers/automation-attribute"));
var form_1 = __importDefault(require("../../molecules/form"));
var styled_1 = __importDefault(require("../../styled"));
var tokens_1 = require("../../tokens");
var _styled_input_1 = require("../_styled-input");
var icon_1 = __importDefault(require("../icon"));
var selectOpacity = {
    default: 1,
    disabled: 0.5
};
var PLACEHOLDER_VALUE = "0";
var valueIsUndefined = function (value) { return value === undefined || value === null; };
var isGroup = function (option) { return option.groupName && option.items; };
var renderOption = function (option, idx) {
    if (isGroup(option)) {
        return (React.createElement("optgroup", __assign({ key: idx, label: option.groupName }, automation_attribute_1.default("select.optgroup")), option.items.map(renderOption)));
    }
    return (React.createElement("option", __assign({ key: idx, value: option.value, disabled: option.disabled }, automation_attribute_1.default("select.option")), option.text));
};
var SimpleSelect = function (_a) {
    var options = _a.options, props = __rest(_a, ["options"]);
    var shouldUsePlaceholder = valueIsUndefined(props.value) && valueIsUndefined(props.defaultValue);
    if (shouldUsePlaceholder) {
        props.value = PLACEHOLDER_VALUE;
    }
    return (React.createElement(SimpleSelect.Wrapper, null,
        React.createElement(SimpleSelect.ArrowIcon, { name: "dropdown-fill", size: "14", color: "default" }),
        React.createElement(form_1.default.Field.ContextConsumer, null, function (context) { return (React.createElement(SimpleSelect.Element, __assign({ id: props.id || context.formFieldId }, automation_attribute_1.default("select"), props),
            props.placeholder && (React.createElement("option", __assign({ disabled: true, value: PLACEHOLDER_VALUE }, automation_attribute_1.default("select.option")), props.placeholder)),
            options.map(renderOption))); })));
};
SimpleSelect.Element = styled_1.default(_styled_input_1.StyledInput.withComponent("select"))(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  appearance: none;\n\n  padding-right: ", ";\n\n  height: ", ";\n  opacity: ", ";\n  background-color: ", ";\n"], ["\n  appearance: none;\n\n  padding-right: ", ";\n\n  height: ", ";\n  opacity: ", ";\n  background-color: ", ";\n"])), tokens_1.spacing.large, tokens_1.misc.input.default.height, function (props) { return (props.disabled ? selectOpacity.disabled : selectOpacity.default); }, function (props) { return (props.disabled ? tokens_1.colors.input.backgroundReadOnly : tokens_1.colors.input.background); });
SimpleSelect.Wrapper = styled_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: relative;\n  display: flex;\n  align-items: center;\n"], ["\n  position: relative;\n  display: flex;\n  align-items: center;\n"])));
SimpleSelect.ArrowIcon = styled_1.default(icon_1.default)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  position: absolute;\n  right: 12px;\n  pointer-events: none;\n\n  svg {\n    display: block;\n  }\n"], ["\n  position: absolute;\n  right: 12px;\n  pointer-events: none;\n\n  svg {\n    display: block;\n  }\n"])));
SimpleSelect.defaultProps = {
    options: [],
    placeholder: ""
};
exports.default = SimpleSelect;
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=simple-select.js.map